export type Docker_toolApiHandle =
  | `/containers`
  | `/container/logs`
  | `/container/upload/file`
  | `/container/exec`
  | `/container/start`
  | `/container/stop`
  | `/container/restart`
  | `/container/logs/test`
  | `/settings`
  | `/settings/${string}`
  | `/docker_urls`
  | `/docker_url/connect/test`
  | `/docker_url/${string}`
  | `/docker_url`
  | `/`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface Docker_toolInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = Docker_toolApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<
    T = any,
    R = AxiosResponse<T>,
    P extends string = Docker_toolApiHandle,
  >(url: P, config?: AxiosRequestConfig): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = Docker_toolApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = Docker_toolApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const dockerToolInstance = axios.create({
  baseURL: '/api/docker_tool/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as Docker_toolInstance;

i18n.on('languageChanged', (lng) => {
  dockerToolInstance.defaults.headers.common['Accept-Language'] = lng;
});